<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3 >
        <h4>Create a new Investigator</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3>
        <form action="" @submit.prevent="onCreateInvestigator">
          <v-layout row>
            <v-flex xs12 sm6>
            <v-text-field
              name="investigatorName"
              label="Name"
              v-model="investigatorName"
              id="investigatorName"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="investigatorPhone"
              label="Phone Number"
              v-model="investigatorPhone"
              id="investigatorPhone"
              single-line
            ></v-text-field>
            <v-text-field
              name="investigatorEmail"
              label="Email Address"
              v-model="investigatorEmail"
              id="investigatorEmail"
              single-line
              required
            ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6>
              <v-btn 
              class="primary" 
              :disabled="!formIsValid"
              type="submit">
                Create Investigator
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      investigatorName: '',
      investigatorPhone: '',
      investigatorEmail: '',
      dialog: false
    }
  },
  props: ['id'],
  computed: {
    investigator () {
      return this.$store.getters.loadedInvestigator(this.id)
    },
    investigators () {
      return this.$store.getters.loadedInvestigators
    },
    formIsValid () {
      return this.investigatorName !== ''
    }
  },
  methods: {
    onCreateInvestigator () {
      if (!this.formIsValid) {
        return
      }
      const investigatorData = {
        title: this.investigatorName,
        investigatorPhone: this.investigatorPhone,
        investigatorEmail: this.investigatorEmail
      }
      this.$store.dispatch('createInvestigator', investigatorData)
      this.$router.push('/investigators')
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateInvestigator.vue?cb727368